import LegalDoc from '../components/LegalDoc';
import markdown from '../content/legal/cookie-policy.md?raw';

export default function CookiePolicyScreen() {
  return <LegalDoc markdown={markdown} title="Cookie Policy" />;
}
